import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const Pricing = () => {
	const { t } = useTranslation();
	const primaryColor = "#43bd98";

	const features = t("store.pricing.features", { returnObjects: true });

	const listVariants = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: { staggerChildren: 0.15 },
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, x: -20 },
		show: { opacity: 1, x: 0, transition: { duration: 0.4 } },
	};

	return (
		<section
			id="precios"
			style={{
				backgroundColor: "#f9fdfa",
				padding: "5rem 2rem",
				fontFamily: "'Poppins', sans-serif",
				paddingTop: 150,
				paddingBottom: 150,
			}}
		>
			<div
				style={{ maxWidth: "1100px", margin: "0 auto", textAlign: "center" }}
			>
				{/* Encabezado */}
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					style={{ marginBottom: "3rem" }}
				>
					<p
						style={{
							color: primaryColor,
							fontSize: "0.9rem",
							fontWeight: 600,
							letterSpacing: "1px",
							textTransform: "uppercase",
							marginBottom: "0.5rem",
						}}
					>
						{t("store.pricing.badge")}
					</p>
					<h2
						style={{
							fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
							color: "#1a1a1a",
							fontWeight: 800,
							margin: 0,
						}}
					>
						{t("store.pricing.title")}
					</h2>
				</motion.div>

				<motion.p
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2 }}
					viewport={{ once: true }}
					style={{ fontSize: "1rem", color: "#666", marginTop: "0.5rem" }}
				>
					{t("store.pricing.subtitle.line1")}
					<br />
					<span style={{ fontWeight: 600 }}>
						{t("store.pricing.subtitle.line2")}
					</span>
				</motion.p>

				{/* Tarjeta */}
				<div
					style={{
						marginTop: "3rem",
						display: "flex",
						justifyContent: "center",
						boxSizing: "border-box",
					}}
				>
					<motion.div
						initial={{ opacity: 0, scale: 0.95 }}
						whileInView={{ opacity: 1, scale: 1 }}
						transition={{ duration: 0.6, ease: "easeOut" }}
						viewport={{ once: true, amount: 0.3 }}
						style={{
							backgroundColor: "#fff",
							borderRadius: "20px",
							boxShadow: "0 12px 40px rgba(0,0,0,0.06)",
							padding: "2.5rem",
							width: "100%",
							maxWidth: "440px",
							textAlign: "left",
						}}
					>
						<h3
							style={{
								fontSize: "1.3rem",
								fontWeight: 700,
								marginBottom: "0.3rem",
								color: "#222",
							}}
						>
							{t("store.pricing.planTitle")}
						</h3>
						<p style={{ fontSize: "0.9rem", color: "#777" }}>
							{t("store.pricing.planDescription")}
						</p>

						{/* Precio */}
						<div style={{ marginTop: "1.6rem" }}>
							<del style={{ color: "#bbb", fontSize: "1.2rem" }}>42,99€</del>
							<div
								style={{
									display: "flex",
									alignItems: "flex-end",
									gap: "0.3rem",
								}}
							>
								<span
									style={{
										fontSize: "2.6rem",
										fontWeight: 800,
										color: primaryColor,
										lineHeight: 1,
									}}
								>
									34,99€
								</span>
								<span
									style={{
										fontSize: "1rem",
										color: "#666",
										marginBottom: "4px",
									}}
								>
									/mes
								</span>
							</div>
							<p
								style={{
									fontSize: "0.75rem",
									color: "#999",
									marginTop: "0.3rem",
								}}
							>
								{t("store.pricing.vat")}
							</p>
						</div>

						{/* Lista de ventajas */}
						<motion.ul
							variants={listVariants}
							initial="hidden"
							whileInView="show"
							viewport={{ once: true, amount: 0.3 }}
							style={{
								padding: 0,
								marginTop: "2rem",
								marginBottom: "2rem",
								listStyle: "none",
							}}
						>
							{features.map((item, idx) => (
								<motion.li
									key={idx}
									variants={itemVariants}
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: "0.75rem",
										fontSize: "0.92rem",
										color: "#444",
										lineHeight: 1.5,
									}}
								>
									<CheckCircle
										size={18}
										style={{
											color: primaryColor,
											marginRight: "0.6rem",
											marginTop: "2px",
											flexShrink: 0,
										}}
									/>
									{item}
								</motion.li>
							))}
						</motion.ul>

						{/* Botón */}
						<motion.a
							href="https://creator.applaby.com/?onboarding=true&appType=Ecommerce&appSubtype=Ecommerce"
							whileHover={{ scale: 1.03 }}
							whileTap={{ scale: 0.97 }}
							style={{
								display: "block",
								width: "100%",
								backgroundColor: primaryColor,
								color: "#fff",
								textAlign: "center",
								padding: "0.9rem 1.5rem",
								borderRadius: "10px",
								textDecoration: "none",
								fontWeight: 600,
								fontSize: "1rem",
							}}
						>
							{t("store.pricing.button")}
						</motion.a>
					</motion.div>
				</div>
			</div>
		</section>
	);
};

export default Pricing;
